export enum StatusEnum {
  Pending = 'pending',
  Diagnosed = 'diagnosed',
  Undiagnosable = 'undiagnosable',
  OverdueFollowup = 'overdueFollowup',
  Draft = 'draft',
}
